
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Defective Asset Replacement</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="defect?.projectId &amp;&amp; defect?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: defect?.projectId}">{{ defect?.projectName }}</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/sites']" [queryParams]="{projectId: defect?.projectId}">Sites</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/site']" [queryParams]="{id: defect?.siteId}">{{ defect?.siteName }}</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/device-defects']" [queryParams]="{siteId: defect?.siteId}">Defective Asset Replacements</a></li>
        <li class="breadcrumb-item active" *ngIf="defect?.name">{{ defect?.name }}</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item" *ngIf="defect">
        <h4>{{ defect.name }}</h4>
        <hr>
        <property-container>
          <property-item><a *ngIf="defect.workflowId" [routerLink]="['/workflow', defect.workflowId]">Enter Workflow</a></property-item>
        </property-container>
        <property-container>
          <property-item>{{ defect.assetsCount }} Asset(s) Related</property-item>
        </property-container>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>